module.exports = __webpack_public_path__ + "f32eacef6c921a7e25a16617757f5f7b.svg";